import { Icon, IconProps } from '@chakra-ui/react'

export default function TrashDeleteIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#D5474C'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5418 21.0038H8.456C7.27981 21.0038 6.30191 20.0982 6.2117 18.9255L5.24609 6.37266H18.7517L17.7861 18.9255C17.6959 20.0982 16.718 21.0038 15.5418 21.0038V21.0038Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0028 6.37266H3.99609"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18602 2.99625H14.8134C15.4349 2.99625 15.9388 3.50014 15.9388 4.12172V6.37266H8.06055V4.12172C8.06055 3.82323 8.17912 3.53696 8.39019 3.32589C8.60126 3.11483 8.88752 2.99625 9.18602 2.99625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99805 17.0021H13.9997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
